
import {Component, Vue} from 'vue-facing-decorator';

export default class Success extends Vue {


}
